/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Config\Config.ts
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 16th July 2024 12:08:04
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { PathConfigType, BackEndConfigType, ConfigCommonType, ConfigType, CookieConfigType, MapAPIType } from "Config/Config.type";

/**
 * The enum of the modes
 */
const ENUM_MODE = {
  DEV: "dev",
  PROD: "prod",
  STAGING: "staging"
};

const mapAPI: MapAPIType = {
  KEY: "68e91e0d518a45269b903042c76dada0",
  ADDR: "https://api.geoapify.com/v1/geocode/autocomplete"
}

/**
 * Config shared between the different modes
 */
const Common: ConfigCommonType = {
  // LANGUAGES: ["fr" : "es", "es" : "fr", "en"],
  NB_PAGES: 1,
  LANGUAGES: ["fr", "en"],
  GEARS: ["manual", "automatic"],
  CARSTATUS: ["selling", "sold", "reserved", "archived"],
  MAP_API: mapAPI,
};

const Paths: PathConfigType = {
  LOGIN: "/auth/login_admin",
  REFRESH: "/auth/refresh",
  ADD_USER: "/users/create",
  ADD_ADMIN: "/users/register_admin",
  GET_BRANDS: "/autobiz/brands",
  GET_USERS_BY_COMMERCIAL: "/users/commercial",
  USERS: "/users",
  USERSCOMMERCIALS: "/users/commercials",
  MYUSERS: "/users/mine",
  CARS: "/car",
  GET_CAR_EQUIPMENT: "/car/equipment",
  GET_CAR_PICTURE: "/car/pictures",
  CARSYNCHRO: "/car/synchro",
  SEENCAR: "/seencars",
  GROUPS: "/groups",
  GROUPSMANAGE: "/groups/manage",
  USERSGROUPS: "/users/groups",
  COMPANIES: "/companies",
  USERINFO: "/info/users",
  CONNEXIONS: "/connexions",
  FAVORITE: "/favorites",
  INSELL: "/insell",
  SENDMESSAGES: "/messages/send",
  MESSAGES: "/messages",
  CONNEXIONINFO: "/info/connexions",
  SEENCARINFO: "/info/seencars",
  OFFERCARINFO: "/info/offers",
  USAGEINFO: "/info/usage",
  CARSINFO: "/info/cars",
  LANGUAGES: "/languages",
  PARKS: "/parks",
  OFFER: "/offers",
  EXTRACT_SELLS: "/extract_sell",
  COLLECTIONS: "/visuals/collections",
  VISUALS: "/visuals",
};

const DevBack: BackEndConfigType = {
  BASEURL: "http://localhost:6780/api",
  PATHS: Paths,
};

const DevFront: BackEndConfigType = {
  BASEURL: "http://localhost:3200",
  PATHS: Paths,
};

const DevCookie: CookieConfigType = {
  COOKIE_TIME_DAYS: 0.5,
  // COOKIE_TIME_DAYS: 0.0003472,
  COOKIE_TIME_REFRESH_DAYS: 90,
};

const StagingBack: BackEndConfigType = {
  BASEURL: "https://testing-api.mobybuy.fr/api",
  PATHS: Paths,
};

const StagingFront: BackEndConfigType = {
  BASEURL: "https://testing-front.mobybuy.fr",
  PATHS: Paths,
};

const ProdFront: BackEndConfigType = {
  BASEURL: "https://www.mobybuy.fr",
  PATHS: Paths,
};

const StagingCookie: CookieConfigType = {
  COOKIE_TIME_DAYS: 0.5,
  COOKIE_TIME_REFRESH_DAYS: 90,
};

const ProdBack: BackEndConfigType = {
  BASEURL: "https://api.mobybuy.fr/api",
  PATHS: Paths,
};

const ProdCookie: CookieConfigType = {
  COOKIE_TIME_DAYS: 0.5,
  COOKIE_TIME_REFRESH_DAYS: 90,
};

/**
 * The internal config for the dev mode
 */
const Dev: ConfigType = {
  COMMON: Common,
  BACKEND: DevBack,
  FRONTEND: DevFront,
  COOKIE: DevCookie,
  MODE: ENUM_MODE.DEV,
};

/**
 * The internal config for staging mode
 */
const Staging: ConfigType = {
  COMMON: Common,
  BACKEND: StagingBack,
  FRONTEND: StagingFront,
  COOKIE: StagingCookie,
  MODE: ENUM_MODE.STAGING,
};

/**
 * The internal config for production mode
 */
const Prod: ConfigType = {
  COMMON: Common,
  BACKEND: ProdBack,
  FRONTEND: ProdFront,
  COOKIE: ProdCookie,
  MODE: ENUM_MODE.PROD,
};

let Config: ConfigType;

if (process.env.REACT_APP_AUTOBUY_BACKOFFICE_ENV === ENUM_MODE.PROD) Config = Prod;
else if (process.env.REACT_APP_AUTOBUY_BACKOFFICE_ENV === ENUM_MODE.DEV) Config = Dev;
else if (process.env.REACT_APP_AUTOBUY_BACKOFFICE_ENV === ENUM_MODE.STAGING) Config = Staging;
else throw Error("Invalid mode: " + process.env.REACT_APP_AUTOBUY_BACKOFFICE_ENV);

export default Config;
